'use client';

import { useEffect } from 'react';

interface Props {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function Error({ error, reset }: Props) {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center text-center px-4">
      <p className="text-7xl mb-6">⚠️</p>
      <h2
        className="font-display font-bold mb-3 text-2xl"
        style={{ color: 'var(--color-text-primary)' }}
      >
        Something went wrong
      </h2>
      <p className="max-w-md mb-8" style={{ color: 'var(--color-text-secondary)' }}>
        An unexpected error occurred. Please try again.
      </p>
      <button onClick={reset} className="btn-primary">
        Try Again
      </button>
    </div>
  );
}
